import {ordoroFetch} from './ordoroFetch.js'
import {stringify} from './querystring.js'

export function formatAPIURL(url, query) {
  if (!url.match(/\/$/) && !url.match(/^\/v3/)) {
    url = url + '/'
  }

  return `${window.ORDORO_BOOTSTRAP.env.PAPPY_ENV_API_URL}${url}${query ? `?${stringify(query)}` : ''}`
}

export function apiFetch(method, url, data, options) {
  return ordoroFetch(
    method,
    formatAPIURL(url, method === 'get' && data),
    data,
    options,
  )
}

export default {
  head(url, data, options) {
    return apiFetch('head', url, data, options)
  },
  get(url, data, options) {
    return apiFetch('get', url, data, options)
  },
  put(url, data, options) {
    return apiFetch('put', url, data, options)
  },
  post(url, data, options) {
    return apiFetch('post', url, data, options)
  },
  patch(url, data, options) {
    return apiFetch('patch', url, data, options)
  },
  delete(url, data, options) {
    return apiFetch('delete', url, data, options)
  },
}
